'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryFull = function DeviceBatteryFull(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
  );
};
DeviceBatteryFull = (0, _pure2.default)(DeviceBatteryFull);
DeviceBatteryFull.displayName = 'DeviceBatteryFull';
DeviceBatteryFull.muiName = 'SvgIcon';

exports.default = DeviceBatteryFull;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/device/battery-full.js
 ** module id = 1831
 ** module chunks = 0
 **/